<template>
    <timeoff-cutoff :teamId="teamId" :pageKey="pageKeys.timeoff_company_approver"></timeoff-cutoff>
</template>

<script>
import pageKeys from '@/common/pagekeys'
export default {     
    name: 'CompanyTimeOffs',
    metaInfo: {
        title: 'Company Time Offs',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Company Time Offs' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'timeoff-cutoff': () => import('@/components/TimeOff/TimeOffCutOff.vue')
    },   
    data () {
      return {
        teamId: 0,
        pageKeys: null
      }
    },
    methods: {},
    async created() {
        this.pageKeys = pageKeys

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Time Offs'
        })
    },
    computed: {}
}
</script>